export { AccordionSection } from './element-legacy'

/* eslint no-unused-vars: 0 */
export enum openState {
  Closed,
  Closing,
  Opening,
  Opened,
}

export interface IProps {
  title?: string
  renderTitleBlock?: () => React.ReactNode
  children: React.ReactNode
  hasLine?: boolean // default true
  largeChevron?: boolean // default false
  backgroundColor?: string
  isActive?: boolean
  isOpen?: openState
  setIsActive?: (isActive: boolean) => void
}
